/**
 * Returns a new array with only unique values.
 * For primitive values, uses direct comparison.
 * For objects, use the optional `key` parameter to specify which property to use for uniqueness.
 */
export function uniq<T>(array: T[], key?: keyof T): T[] {
  if (key) {
    const seen = new Set();
    return array.filter((item) => {
      const value = item[key];
      if (seen.has(value)) {
        return false;
      }
      seen.add(value);
      return true;
    });
  }

  return [...new Set(array)];
}
